var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TwoFactorSetupWrapper',{on:{"setup-completed":_vm.handleSetupCompleted,"setup-cancelled":_vm.handleSetupCancelled,"setup-error":_vm.handleSetupError}})
}
var staticRenderFns = []

export { render, staticRenderFns }